import { render, staticRenderFns } from "./payways-list.vue?vue&type=template&id=290a4dfa&scoped=true"
import script from "./payways-list.vue?vue&type=script&lang=js"
export * from "./payways-list.vue?vue&type=script&lang=js"
import style0 from "./payways-list.vue?vue&type=style&index=0&id=290a4dfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a4dfa",
  null
  
)

export default component.exports